module.exports = __webpack_public_path__ + "img/minus-mini.2c534e76.svg";